"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledExpandContentBox = exports.StyledContentBoxWrapper = exports.StyledContentBoxTitle = exports.StyledContentBoxContent = exports.StyledContentBoxBack = exports.StyledContentBox = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _tachyons = require("../../framework/tachyons");

var _ty = _interopRequireDefault(require("../../framework/ty"));

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9, _templateObject10, _templateObject11, _templateObject12;

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var StyledContentBox = _styledComponents["default"].div.withConfig({
  displayName: "ContentBoxstyles__StyledContentBox",
  componentId: "sc-9w64v1-0"
})(["", " ", " ", "{", " ", "}"], (0, _ty["default"])(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2["default"])(["\n    w-100 relative overflow-hidden flex-auto flex-column flex\n    ", "\n  "])), function (_ref) {
  var contentBox = _ref.theme.contentBox;
  return contentBox === null || contentBox === void 0 ? void 0 : contentBox.appearance;
}), function (_ref2) {
  var contentBox = _ref2.theme.contentBox;
  return contentBox === null || contentBox === void 0 ? void 0 : contentBox.overrides;
}, _tachyons.breakpoints.s, function (_ref3) {
  var isCollapsed = _ref3.isCollapsed,
      plain = _ref3.plain;
  return !plain && !isCollapsed && (0, _ty["default"])(_templateObject2 || (_templateObject2 = (0, _taggedTemplateLiteral2["default"])(["fixed left-0 right-0 top-0 bottom-0"])));
}, function (_ref4) {
  var isCollapsed = _ref4.isCollapsed,
      plain = _ref4.plain;
  return !plain && !isCollapsed && "z-index: 102;";
});

exports.StyledContentBox = StyledContentBox;

var StyledContentBoxBack = _styledComponents["default"].div.withConfig({
  displayName: "ContentBoxstyles__StyledContentBoxBack",
  componentId: "sc-9w64v1-1"
})(["", " ", " & > div{", "}", "{", "}"], (0, _ty["default"])(_templateObject3 || (_templateObject3 = (0, _taggedTemplateLiteral2["default"])(["w-100 ph2 pv2 top-0 fixed z-2 bg-white-90 f6"]))), function (_ref5) {
  var isContentAtTop = _ref5.isContentAtTop;
  return !isContentAtTop && 'box-shadow: 0 2px 10px rgb(0 0 0 / 40%);';
}, (0, _ty["default"])(_templateObject4 || (_templateObject4 = (0, _taggedTemplateLiteral2["default"])(["\n      pointer inline-flex items-center\n      ", "\n    "])), function (_ref6) {
  var link = _ref6.theme.link;
  return link === null || link === void 0 ? void 0 : link["default"];
}), _tachyons.breakpoints.ns, (0, _ty["default"])(_templateObject5 || (_templateObject5 = (0, _taggedTemplateLiteral2["default"])(["dn"]))));

exports.StyledContentBoxBack = StyledContentBoxBack;

var StyledContentBoxContent = _styledComponents["default"].div.withConfig({
  displayName: "ContentBoxstyles__StyledContentBoxContent",
  componentId: "sc-9w64v1-2"
})(["", " ", ""], (0, _ty["default"])(_templateObject6 || (_templateObject6 = (0, _taggedTemplateLiteral2["default"])(["\n    lh-copy w-100\n    ", "}\n    ", "\n    ", "\n  "])), function (_ref7) {
  var contentBox = _ref7.theme.contentBox,
      hasTitle = _ref7.hasTitle;
  return (contentBox === null || contentBox === void 0 ? void 0 : contentBox.title.indexOf('b--')) <= 0 && hasTitle ? 'ph3 pb3' : 'pa3';
}, function (_ref8) {
  var contentBox = _ref8.theme.contentBox;
  return contentBox === null || contentBox === void 0 ? void 0 : contentBox.content;
}, function (_ref9) {
  var isCollapsed = _ref9.isCollapsed,
      plain = _ref9.plain;
  return isCollapsed && !plain && 'h4';
}), function (_ref10) {
  var isCollapsed = _ref10.isCollapsed,
      fadeWhenCollapsed = _ref10.fadeWhenCollapsed,
      plain = _ref10.plain;
  return isCollapsed && fadeWhenCollapsed && !plain && (0, _styledComponents.css)(["&:after{position:absolute;height:70%;bottom:0;left:0;right:0;background:-webkit-gradient( linear,left top,left bottom,color-stop(0,hsla(0,0%,100%,0)),color-stop(54%,hsla(0,0%,100%,0.75)),to(#fff) );background:linear-gradient(180deg,hsla(0,0%,100%,0),hsla(0,0%,100%,0.75) 54%,#fff);clear:both;content:' ';display:block;font-size:0;}"]);
});

exports.StyledContentBoxContent = StyledContentBoxContent;

var StyledContentBoxTitle = _styledComponents["default"].h2.withConfig({
  displayName: "ContentBoxstyles__StyledContentBoxTitle",
  componentId: "sc-9w64v1-3"
})(["", " & > svg{", " fill:", ";pointer-events:none;}"], (0, _ty["default"])(_templateObject7 || (_templateObject7 = (0, _taggedTemplateLiteral2["default"])(["\n    w-100 ma0 nr3 pa3 fw4 flex justify-between\n    ", "\n    ", "\n  "])), function (_ref11) {
  var contentBox = _ref11.theme.contentBox;
  return contentBox === null || contentBox === void 0 ? void 0 : contentBox.title;
}, function (_ref12) {
  var expandFromTitle = _ref12.expandFromTitle,
      isCollapsed = _ref12.isCollapsed;
  return expandFromTitle && isCollapsed && 'pointer';
}), (0, _ty["default"])(_templateObject8 || (_templateObject8 = (0, _taggedTemplateLiteral2["default"])(["dn-ns f2"]))), function (_ref13) {
  var contentBox = _ref13.theme.contentBox;
  return (contentBox === null || contentBox === void 0 ? void 0 : contentBox.expandArrowColor) || 'blue';
});

exports.StyledContentBoxTitle = StyledContentBoxTitle;

var StyledContentBoxWrapper = _styledComponents["default"].div.withConfig({
  displayName: "ContentBoxstyles__StyledContentBoxWrapper",
  componentId: "sc-9w64v1-4"
})(["", ""], (0, _ty["default"])(_templateObject9 || (_templateObject9 = (0, _taggedTemplateLiteral2["default"])(["\n    w-100 flex-auto flex flex-wrap\n    ", "\n    ", "\n  "])), function (_ref14) {
  var isCollapsed = _ref14.isCollapsed;
  return !isCollapsed && 'pt4 pt0-ns';
}, function (_ref15) {
  var isCollapsed = _ref15.isCollapsed,
      plain = _ref15.plain;
  return !isCollapsed && !plain && 'overflow-y-auto overflow-y-hidden-ns';
}));

exports.StyledContentBoxWrapper = StyledContentBoxWrapper;

var StyledExpandContentBox = _styledComponents["default"].div.withConfig({
  displayName: "ContentBoxstyles__StyledExpandContentBox",
  componentId: "sc-9w64v1-5"
})(["", " & > div{", " &:hover{", "}}"], (0, _ty["default"])(_templateObject10 || (_templateObject10 = (0, _taggedTemplateLiteral2["default"])(["w-100 relative bg-white ph3 pv2 f6"]))), (0, _ty["default"])(_templateObject11 || (_templateObject11 = (0, _taggedTemplateLiteral2["default"])(["dib pointer ", ""])), function (_ref16) {
  var _link$types, _link$types$standard;

  var link = _ref16.theme.link;
  return link === null || link === void 0 ? void 0 : (_link$types = link.types) === null || _link$types === void 0 ? void 0 : (_link$types$standard = _link$types.standard) === null || _link$types$standard === void 0 ? void 0 : _link$types$standard["default"];
}), (0, _ty["default"])(_templateObject12 || (_templateObject12 = (0, _taggedTemplateLiteral2["default"])(["", ""])), function (_ref17) {
  var _link$types2, _link$types2$standard;

  var link = _ref17.theme.link;
  return link === null || link === void 0 ? void 0 : (_link$types2 = link.types) === null || _link$types2 === void 0 ? void 0 : (_link$types2$standard = _link$types2.standard) === null || _link$types2$standard === void 0 ? void 0 : _link$types2$standard.hover;
}));

exports.StyledExpandContentBox = StyledExpandContentBox;